import BaseApi from "../baseApi";


export default class DepartmentResourceRelationApi extends BaseApi {
    async get(departmentId: string): Promise<LoanCar[]> {
        const url = `/api/DepartmentLoanCar/${departmentId}`;
        return await this.fetchGet(url);
    }

    async delete(id: string): Promise<string> {
        const url = `/api/DepartmentLoanCar/${id}`;
        return await this.fetchDelete(url);
    }
    async add(departmentId: string, regNumber: string): Promise<LoanCar> {
        const url = `/api/DepartmentLoanCar/${departmentId}/${regNumber}`;
        return await this.fetchPost(url);
    }
    async deleteDamage(carid: string, damageId: string): Promise<string> {
        const url = `/api/DepartmentLoanCar/damage/remove/${carid}/${damageId}`;
        return await this.fetchDelete(url);
    }
    async addDamage(departmentId: string,carid: string, data: CarDamage): Promise<CarDamage> {
        const url = `/api/DepartmentLoanCar/damage/add/${carid}/`;
        const {id, ...rest} = data;
        return await this.fetchPost(url, rest);
    }
}
